module.exports = __webpack_public_path__ + "static/img/ball.f7cf6a5b.png";